import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import styled from '@emotion/styled';
import { Box, NavigationLink } from '..';

// Note, unlike NavigationMenuItem this will show
// active on partial path matches

const propTypes = {
  children: PropTypes.node,
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};
const defaultProps = {
  children: null,
};

// Do not highlight link text when active
const LinkText = styled.span`
  color: ${props => props.theme.color};
  padding-left: ${props => props.theme.space_inline_sm};
`;


function NavigationMenuGroup({
  children, icon, title, href,
}) {
  return (
    <Route path={href}>
      {({ match }) => (
        <div>
          <NavigationLink href={href} match={!!match} large>
            { icon }
            <LinkText match={match}>{ title }</LinkText>
          </NavigationLink>
          <Box marginLeft="lg" paddingLeft="lg">
            { children }
          </Box>
        </div>
      )}
    </Route>
  );
}

NavigationMenuGroup.propTypes = propTypes;
NavigationMenuGroup.defaultProps = defaultProps;
export default NavigationMenuGroup;
